import { useUserBalanceStore } from '@/entities/balance';
import { useCurrentUser, useIsPaidTrial } from '@/entities/user/currentUser';

export const useIsOwnPaidTrial = () => {
  const { hasEnterprisePlan } = useUserBalanceStore();
  const { data: subscription } = useCurrentUser((data) => data.subscription);

  return useIsPaidTrial(subscription) === true && !hasEnterprisePlan;
};
